export default __webpack_public_path__ + "static/media/p3.38370f56.png";